import React from "react";
import { useData } from "../../../../../components/SiteMap/contexts/DataContext";
import SiteMapBoundaryRoute from "../../../../../components/SiteMap/routes/BoundaryRoute";

const SiteMapBoundaryPage = () => {
  const { boundary } = useData();

  return (
    <>
      <SiteMapBoundaryRoute boundary={boundary} />
    </>
  );
};

export default SiteMapBoundaryPage;
